import { createContext, ReactNode } from "react";
interface IData {
  page: {
    data?: any;
    error?: any;
    // networks: any[];
  };
}

const initialData: IData = {
  page: {
    data: null,
    error: null,
    // networks: [],
  },
};

export const PageContext = createContext(initialData);

interface IProps extends IData {
  children: ReactNode;
}

export const PageProvider = ({ page, children }: IProps) => {
  return (
    <PageContext.Provider value={{ page }}>{children}</PageContext.Provider>
  );
};
